import React from "react"
import Icon from "@kit/design/icon"

export function LayoutPreview() {
  return (
    <div className="flex items-center">
      <div className="w-6 h-6 flex items-center justify-center mr-4">
        <Icon name="layout-masonry" />
      </div>
      <div>Layout</div>
    </div>
  )
}
